var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fixBottom", staticClass: "popup px-16 py-24 p-md-24 p-lg-40" },
    [
      _c("h2", { staticClass: "mb-32" }, [_vm._v("Stel zelf je dag samen")]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-40" }, [
        _vm._v(
          "\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus\n        condimentum hendrerit urna et facilisis.\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-between m-n4" }, [
        _c("div", { staticClass: "flex-1 p-4" }, [
          _c(
            "a",
            {
              staticClass:
                "btn btn-accent d-flex align-items-center whitespace-nowrap text-white w-100",
              staticStyle: { color: "white !important" },
              attrs: {
                href: _vm.route("nl.activities", {
                  categories: "formats"
                })
              }
            },
            [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.svg("view-add-grid", "mr-8"))
                }
              }),
              _vm._v(" Start met\n                een voorbeeld")
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-1 p-4" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-accent-light d-flex align-items-center whitespace-nowrap text-accent w-100",
              staticStyle: { color: "var(--accent) !important" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.svg("pencil-alt", "mr-8")) }
              }),
              _vm._v("\n                Start met een lege dag\n            ")
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }